export type SubscriptionOfferModelFR = {
  expiration: string;
  montant: number;
};

export type SubscriptionOfferModel = {
  expirationDate: string;
  amount: number;
};

export const translateSubscriptionOfferModel = (m: SubscriptionOfferModelFR): SubscriptionOfferModel => {
  return {
    expirationDate: m.expiration,
    amount: m.montant,
  };
};
